import { render, staticRenderFns } from "./detailid.vue?vue&type=template&id=eed96932&scoped=true"
import script from "./detailid.vue?vue&type=script&lang=js"
export * from "./detailid.vue?vue&type=script&lang=js"
import style0 from "./detailid.vue?vue&type=style&index=0&id=eed96932&prod&lang=scss"
import style1 from "./detailid.vue?vue&type=style&index=1&id=eed96932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed96932",
  null
  
)

export default component.exports